
import { FilterMatchMode } from "primevue/api";
import { computed, defineComponent, onMounted, reactive } from "vue";

import ResearchEquipmentRepositoryAPI from "@/modules/research-equipment/research-equipment-repository-api";
import { useI18n } from "vue-i18n";
import { lazyParamsDefault } from "@/utils/pagination-helper";
export default defineComponent({
  setup() {
    const { t } = useI18n();
    const filters = reactive({
      name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const {
      setResearchEquipment,
      setResearchEquipmentCompare,
      getCompareList,
      removeFromCompare,
    } = ResearchEquipmentRepositoryAPI();
    const state = reactive({
      dataLoading: true,
      researchEquipmentGroup: [],
      prompt1: false,
      selectedColumns: [
        {
          header: t("content.comparison.content.table.header.id"),
          field: "id",
        },
        {
          header: t("content.comparison.content.table.header.number"),
          field: "number",
        },
        {
          header: t("content.comparison.content.table.header.equipment"),
          field: "name",
        },
        {
          header: t("content.comparison.content.table.header.organization"),
          field: "researchOrganization",
        },
        {
          header: t("content.comparison.content.table.header.location"),
          field: "location",
        },
        {
          header: t("content.comparison.content.table.header.contact"),
          field: "contactUsers",
        },
        {
          header: t("content.comparison.content.table.header.detailView"),
          field: "link",
        },
      ] as Array<any>,
      columns: [] as Array<any>,
      selectedDataRow: [],
      lazyParams: lazyParamsDefault,
    });

    const onRowSelect = (event: any): void => {
      const length = state.selectedDataRow.length;
      if (length === 1) {
        setResearchEquipment(event.data);
      } else if (length === 2) {
        setResearchEquipmentCompare(event.data);
      } else {
        state.selectedDataRow.shift();
      }
    };

    const onToggle = (value: any) => {
      state.selectedColumns = state.columns.filter((col) =>
        value.includes(col)
      );
    };

    return {
      filters,
      state: computed(() => state),
      getCompareList,
      removeFromCompare,
      onToggle,
      onRowSelect,
    };
  },
});
